import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>8 Valuable Lessons from Joseph Landes</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In the fourth episode of “Technology for a Change,” Season 3, Hady Shaikh, the Principal Product Strategist at TekRevol, interviewed Joseph Landes, the Chief Revenue Officer and Chief Evangelist of Nerdio – An Independent Software Vendor (ISV) demystifying the idea of virtual desktops and empowering MSPs and Enterprise IT professionals to help build highly scalable and sustainable businesses on Microsoft Azure.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;